export default class Sendunit {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      url: '',
      login: '',
      password: '',
      sendunitPoolId: null
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      url: this.url,
      login: this.login,
      password: this.password,
      sendunitPoolId: this.sendunitPoolId
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sendunit/model.js